import { useCurrentSofa } from '@/hooks/use-current-sofa'
import { useTranslate } from '@/hooks/use-translate'

// https://react.dev/reference/react-dom/components/title#use-variables-in-the-title

export function DocumentTitle() {
  const appName = useTranslatedAppName()
  return <title>{`${appName}`}</title>
}

export function DocumentTitleWithCurrentSofa() {
  const appName = useTranslatedAppName()
  const current = useCurrentSofa()

  if (!current) return <title>{appName}</title>

  const name = current.sofa?.productData.content.name ?? current.rangeData.displayName

  return <title>{`${appName} | ${name}`}</title>
}

function useTranslatedAppName() {
  const { translateString } = useTranslate()
  // TODO: Specific app title?
  return translateString('startpage.intro.title')
}
